import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

const initialValues = {
    loggedIn: false,
    jwt: null,
    accessTokenExpiresAt: null,
    permissions: [],
    audienceMemberships: [],
    userid: null,
    username: null,
    firstName: null,
    lastName: null,
    email: null,
    passkeyConfigured: false,
    requiresPasskeyEnrollment: false,
    authenticationMethod: null
};

const useUserStore = create(
  persist(
    (set, get) => ({
	...initialValues,
	  setLoggedIn: (value) => set({loggedIn: value}),
    logout: () => set(initialValues),
    login: (jwt,permissions,userid,username,accessTokenExpiresAt = null, audienceMemberships = []) => set({
      loggedIn: true,
      jwt : jwt,
      accessTokenExpiresAt,
      permissions: permissions ?? [],
      audienceMemberships: audienceMemberships ?? [],
      userid: userid,
      username: username,
      firstName: null,
      lastName: null,
      email: null,
      passkeyConfigured: false,
      requiresPasskeyEnrollment: false,
      authenticationMethod: "password"
    }),
    setSession: (session) => set((state) => ({
      loggedIn: true,
      jwt: session?.accessToken ?? null,
      accessTokenExpiresAt: session?.accessTokenExpiresAt ?? null,
      permissions: session?.permissions ?? [],
      audienceMemberships: session?.audienceMemberships ?? [],
      userid: session?.userId ?? null,
      username: session?.username ?? null,
      firstName: session?.firstName ?? state.firstName ?? null,
      lastName: session?.lastName ?? state.lastName ?? null,
      email: session?.email ?? state.email ?? null,
      passkeyConfigured: session?.passkeyConfigured ?? false,
      requiresPasskeyEnrollment: session?.requiresPasskeyEnrollment ?? false,
      authenticationMethod: session?.authenticationMethod ?? state.authenticationMethod ?? null
    })),
    updateProfile: (profile) => set((state) => ({
      username: profile?.username ?? state.username ?? null,
      firstName: profile?.firstName ?? state.firstName ?? null,
      lastName: profile?.lastName ?? state.lastName ?? null,
      email: profile?.email ?? state.email ?? null
    })),
    setJwt: (newJwt, accessTokenExpiresAt = null) => set({jwt : newJwt, accessTokenExpiresAt}),
    setPermissions: (permissions) => set({ permissions: permissions ?? [] }),
    setAudienceMemberships: (audienceMemberships) => set({ audienceMemberships: audienceMemberships ?? [] }),
    getToken: () => get().jwt
    }),
    {
      name: 'MFP-USER', // name of the item in the storage (must be unique)
      storage: createJSONStorage(() => sessionStorage), // (optional) by default, 'localStorage' is used
    }
  )
);

export default useUserStore; 
